import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EmployeeService } from '@common/services/EmployeeService/EmployeeService';
import { ModalService } from '@common/services/ModalService/ModalService';
import { EmployeeDetails } from '@common/models/employeeDetails.model';
import { BreadcrumbLevel } from '@common/models/breadcrumbLevel.model';

@Component({
  templateUrl: './addEditEmployeeView.component.html',
  styleUrls: ['./addEditEmployeeView.component.scss'],
})
export class AddEditEmployeeViewComponent implements OnInit {
  attemptedToSubmit = false;
  submitted = false;
  employeeKey: string;
  employeeDetails: EmployeeDetails;
  mode: string;
  breadcrumbLevels: BreadcrumbLevel[] = [];
  addEditEmployeeForm: FormGroup;

  constructor(
    public employeeService: EmployeeService,
    public router: Router,
    public route: ActivatedRoute,
    public modalService: ModalService,
  ) {}

  ngOnInit() {
    this.addEditEmployeeForm = new FormGroup({
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl('', [Validators.required]),
    });

    this.route.params.subscribe((params) => {
      this.employeeKey = params['employeeKey'];
      this.mode = this.employeeKey ? 'edit' : 'add';

      if (this.employeeKey) {
        this.employeeService.getEmployeeDetails(this.employeeKey)
          .subscribe((data: EmployeeDetails): void => {
            this.employeeDetails = data;

            this.breadcrumbLevels = [
              {
                employeeKey: data.employeeKey,
                employeeName: `${data.employeeFirstName} ${data.employeeLastName}`,
              },
            ];

            this.addEditEmployeeForm.patchValue({
              firstName: data.employeeFirstName ? data.employeeFirstName : '',
              lastName: data.employeeLastName ? data.employeeLastName : '',
              email: data.employeeEmail ? data.employeeEmail : '',
              phone: data.employeePhone ? data.employeePhone : '',
            });
          });
      }
    });
  }

  handleError(err) {
    if (err.error.email) {
      this.modalService.openModal({ type: 'userEmailExists' });
    } else {
      this.modalService.openModal({ type: 'errorOccurred' });
    }

    this.submitted = false;
  }

  onSubmit(): void {
    this.attemptedToSubmit = true;

    for (const control in this.addEditEmployeeForm.controls) {
      if (this.addEditEmployeeForm.controls.hasOwnProperty(control)) {
        this.addEditEmployeeForm.controls[control].markAsTouched();
      }
    }

    if (this.addEditEmployeeForm.valid && !this.submitted) {
      if (this.mode === 'add') {
        this.employeeService.addEmployee(this.addEditEmployeeForm.value)
          .subscribe(
            (res) => {
              this.router.navigateByUrl('/employees');
              this.modalService.openModal({ type: 'employeeAdded' });
            },
            this.handleError.bind(this),
          );

        this.submitted = true;
      } else if (this.mode === 'edit') {
        this.employeeService.editEmployee(this.employeeKey, this.addEditEmployeeForm.value)
          .subscribe(
            (res: null) => {
              this.router.navigateByUrl(`/employees/${this.employeeKey}`);
              this.modalService.openModal({ type: 'changesSaved' });
            },
            this.handleError.bind(this),
          );

        this.submitted = true;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/employees/views/addEditEmployeeView/addEditEmployeeView.component.ts